import { Text, theme } from '@prose-ui';
import { legacyTheme, styled } from '@prose-ui/legacy';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${theme.spacing['4x']};
  padding: 0 ${theme.spacing['6x']};

  ${legacyTheme.breakpoints.up('sm')} {
    width: 70%;
  }
  ${legacyTheme.breakpoints.up('md')} {
    padding: 0;
  }
`;

type IngredientsTitleProps = {
  title: string;
  subtitle: string;
};

export const IngredientsTitle = ({ title, subtitle }: IngredientsTitleProps) => {
  return (
    <Wrapper>
      <Text color="primary.300" variant="h3">
        {title}
      </Text>
      <Text color="primary.300" variant="body4regular">
        {subtitle}
      </Text>
    </Wrapper>
  );
};
